import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { endpoints } from './../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { BaseResult } from '../../shared/models/base.result.model';
import { Sacado } from './models/sacado.model';
import { Parametros } from './models/parametros';
import { EmitBillet } from './models/emit-billet';
import { Billet } from './models/billet';

@Injectable()
export class CollectionService {
	private url = endpoints.collection;
	private sacado: Sacado;
	private date: string;
	private value: number;
	private billet: Billet;

	constructor(private http: HttpClient) { }

	get(): Observable<BaseResult<Sacado[]>> {
		return this.http.get<BaseResult<Sacado[]>>(this.url.base);
	}

	getById(cpfCnpj: string): Observable<BaseResult<Sacado[]>> {
		return this.http.get<BaseResult<Sacado[]>>(`${this.url.base}/${cpfCnpj}/`);
	}

	post(model: Sacado): Observable<BaseResult<Sacado>> {
		return this.http.post<BaseResult<Sacado>>(this.url.base, model);
	}

	put(model: Sacado): Observable<BaseResult<Sacado>> {
		return this.http.put<BaseResult<Sacado>>(this.url.base, model);
	}

	delete(cpfCnpj: string): Observable<BaseResult<any>> {
		return this.http.delete<BaseResult<any>>(`${this.url.base}/${cpfCnpj}/`);
	}

	getBilletParameters(): Observable<BaseResult<Parametros>> {
		return this.http.get<BaseResult<Parametros>>(`${endpoints.billet.parameters}`);
	}

	emitBillet(model: EmitBillet): Observable<BaseResult<Billet>> {
		return this.http.post<BaseResult<Billet>>(endpoints.billet.base, model);
	}

	getBilletPdf(numeroTitulo: number): Observable<BaseResult<any>> {
		return this.http.get<BaseResult<any>>(`${endpoints.billet.base}/${numeroTitulo}/pdf`);
	}

	setDateToEmit = (date: string) => this.date = date;
	getDateToEmit = (): string => this.date;

	setValueToEmit = (value: number) => this.value = value;
	getValueToEmit = (): number => this.value;

	setSacadoToEmit = (sacado: Sacado) => this.sacado = sacado;
	getSacadoToEmit = (): Sacado => this.sacado;

	setBilletEmited = (billet: Billet) => this.billet = billet;
	getBilletEmited = (): Billet => this.billet;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/collection/collection.service.ts